const documentRoot = document.documentElement;
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

documentRoot.classList.add("js");

function motionEnabled() {
  if (documentRoot.dataset.motionForce === "off") return false;
  if (documentRoot.dataset.motionForce === "on") return true;
  return !reducedMotion.matches;
}

function markIn(element) {
  element.setAttribute("data-motion-in", "");
}

const OBSERVED =
  "[data-motion-sweep], [data-motion-draw], [data-motion-rule], [data-motion-steps], [data-motion-band]";
const PLAYABLE = `[data-motion-reveal], [data-motion-hero], [data-motion-hero-media], ${OBSERVED}`;

function observeOnce(element, threshold = 0.18) {
  if (!motionEnabled() || !("IntersectionObserver" in window)) {
    markIn(element);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        markIn(entry.target);
        observer.unobserve(entry.target);
      }
    },
    { threshold, rootMargin: "0px 0px -6% 0px" },
  );

  observer.observe(element);
}

function thresholdFor(element) {
  if (element.hasAttribute("data-motion-sweep") || element.hasAttribute("data-motion-draw")) {
    return 0.6;
  }
  if (element.hasAttribute("data-motion-rule")) return 0.4;
  return 0.25;
}

function initializeMotion(scope = document) {
  documentRoot.dataset.motion = motionEnabled() ? "on" : "off";

  scope.querySelectorAll("[data-motion-hero]").forEach((hero) => {
    if (hero.dataset.motionBound) return;
    hero.dataset.motionBound = "true";
    const media = hero.querySelector("[data-motion-hero-media]");
    const reveals = hero.querySelectorAll("[data-motion-reveal], [data-motion-rule]");
    const revealHero = () => {
      markIn(hero);
      if (media) markIn(media);
      reveals.forEach(markIn);
    };
    if (!motionEnabled()) revealHero();
    else requestAnimationFrame(() => requestAnimationFrame(revealHero));
  });

  scope.querySelectorAll("[data-motion-reveal]").forEach((element) => {
    if (element.closest("[data-motion-hero]") || element.dataset.motionBound) return;
    element.dataset.motionBound = "true";
    observeOnce(element);
  });

  scope.querySelectorAll(OBSERVED).forEach((element) => {
    if (element.closest("[data-motion-hero]") || element.dataset.motionBound) return;
    element.dataset.motionBound = "true";
    observeOnce(element, thresholdFor(element));
  });

  scope.querySelectorAll("[data-motion-header]").forEach((header) => {
    if (header.dataset.motionBound) return;
    header.dataset.motionBound = "true";
    const updateHeader = () => header.toggleAttribute("data-motion-stuck", window.scrollY > 24);
    window.addEventListener("scroll", updateHeader, { passive: true });
    updateHeader();
  });
}

function syncMotionPreference() {
  documentRoot.dataset.motion = motionEnabled() ? "on" : "off";
  if (!motionEnabled()) document.querySelectorAll(PLAYABLE).forEach(markIn);
}

function replayMotion() {
  document.querySelectorAll(PLAYABLE).forEach((element) => {
    element.removeAttribute("data-motion-in");
    delete element.dataset.motionBound;
  });
  initializeMotion();
}

window.TrailFreqsMotion = {
  init: initializeMotion,
  sync: syncMotionPreference,
  replay: replayMotion,
  reduced: () => !motionEnabled(),
};

reducedMotion.addEventListener("change", syncMotionPreference);
document.addEventListener("shopify:section:load", (event) => initializeMotion(event.target));

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initializeMotion());
} else {
  initializeMotion();
}
